import { FormattingService } from 'src/app/core/services/formatting.service';
import { Component, OnInit, Input, EventEmitter, Output, ViewChild, forwardRef } from '@angular/core';
import { DxTextBoxComponent } from 'devextreme-angular';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-numeric-text-box',
    templateUrl: './numeric-text-box.component.html',
    styleUrls: ['./numeric-text-box.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => NumericTextBoxComponent), // replace name as appropriate
            multi: true
        }
    ],
    standalone: false
})
export class NumericTextBoxComponent implements OnInit, ControlValueAccessor {
  _value: string;
  @Input() get value() {
    return this._value;
  }
  set value(val) {
    this._value = val;
    this.formatDisplayValue();
  }
  @Output() valueChange = new EventEmitter<string>();

  displayValue: string;
  isEditing: boolean;
  @ViewChild('editInput') editInput: DxTextBoxComponent;
  @Input() isCurrency: boolean;

  constructor(private readonly formattingService: FormattingService) { }

  ngOnInit() {
    this.formatDisplayValue()
  }

  onFocusIn() {
    this.isEditing = true;
    this.value = this.formattingService.getDisplayFormattedNumber(this.value, this.isCurrency);
    this.value = this.formattingService.removeThousandSeparators(this.value);
    setTimeout(() => {
      this.editInput.instance.focus();
    });
  }

  onFocusOut() {
    this.isEditing = false;
    this.formatDisplayValue();
    this.value = this.formattingService.getNumber(this.value);
    this.valueChange.emit(this.value);
    this.onTouch(this.value);
    this.onChange(this.value);
  }

  formatDisplayValue() {
    this.displayValue = this.formattingService.getDisplayFormattedNumber(this.value, this.isCurrency);
  }

  onChange: any = () => { }

  onTouch: any = () => { }

  writeValue(value: any) {
    this.value = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }
}
